import { lazy } from "react";

const MainPage = lazy(() => import("./page"));

const routes = [
  {
    path: "/administration/medical-equipment-type",
    component: MainPage,
    exact: false,
    name: "Equipos Médicos - Tipos"
  }
];

export default routes;
